import React from 'react';
import { Box, Banner } from '@fullstory/components';
import { TimeRange } from '@fullstory/proto/fs/api/segment';
import { usePlaylistRetentionError } from './usePlaylistRetentionError';

export const RETENTION_ERROR_TEST_ID = 'retention-error';
interface PlaylistRetentionErrorProps {
  timeRange: TimeRange | null;
}

export const PlaylistRetentionError: React.FC<PlaylistRetentionErrorProps> = ({ timeRange }) => {
  const { hasError, errorMessage } = usePlaylistRetentionError(timeRange);

  if (!hasError) {
    return null;
  }

  return (
    <Box testId={RETENTION_ERROR_TEST_ID}>
      <Banner variant="warning" description={errorMessage} />
    </Box>
  );
};
